import { ReactNode } from 'react';

type FieldRowProps = {
  label: string;
  children: ReactNode;
};

export const FieldRow = ({ label, children }: FieldRowProps) => (
  <span className="leading-6 text-black">
    <span>{label} </span>
    {children}
  </span>
);
